import { render, staticRenderFns } from "./ReviewBoard.vue?vue&type=template&id=5ca83402&"
import script from "./ReviewBoard.vue?vue&type=script&lang=js&"
export * from "./ReviewBoard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewBoard.vue?vue&type=style&index=0&id=5ca83402&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports